import * as React from 'react';
import { MyQuotationLine } from '../../../models/quotations/MyQuotation';
import {
    Box,
    Table,
    TableCell,
    TableHead,
    TableRow,
    TableBody,
} from '@mui/material';
import { formatPrice } from '../../../utils/numberFormatter';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledBoxWrapper = styled(Box)(() => ({
    '.MuiTableCell-head': {
        border: 'none',
    },
    '.MuiTableRow-root:not(:last-child)': {
        '.MuiTableCell-body': {
            border: 'none',
        },
    },
}));
const StyledBoxSummaryWrapper = styled(Box)(() => ({
    '.MuiTableCell-body': {
        border: 'none',
    },
}));

export const MyQuotationProductsSummary: React.FC<{
    lines: MyQuotationLine[];
}> = (props) => {
    const { lines } = props;

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATION_DETAILS.SUMMARY',
    });

    const netSum = lines.reduce((accumulator, object) => {
        return accumulator + object.netLineAmount;
    }, 0);

    return (
        <>
            <StyledBoxWrapper>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="right">{t('NETTO')}</TableCell>
                            <TableCell align="right"> {t('VAT')}</TableCell>
                            <TableCell align="right"> {t('GROSS')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ width: '58%' }}></TableCell>
                            <TableCell align="right" sx={{ width: '14%' }}>
                                {formatPrice(netSum)} Ft
                            </TableCell>
                            <TableCell sx={{ width: '14%' }} align="right">
                                27%
                            </TableCell>
                            <TableCell sx={{ width: '14%' }} align="right">
                                {' '}
                                {formatPrice(netSum * 1.27)} Ft
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </StyledBoxWrapper>
            <StyledBoxSummaryWrapper>
                <Table aria-label="simple table">
                    <TableBody>
                        <TableRow>
                            <TableCell>{t('SUM')}</TableCell>
                            <TableCell align="right">
                                {formatPrice(netSum * 1.27)} Ft
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </StyledBoxSummaryWrapper>
        </>
    );
};
